import { app } from "@/main";

const state = {
  lang: ""
};

const getters = {
  currentLang: state => state.lang
};

const mutations = {
  changeLanguage(state, payload) {
    state.lang = payload;
    app.$i18n.locale = payload;
  }
};

const actions = {
  changeLanguage({ commit }, payload) {
    commit("changeLanguage", payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
